<template>
  <app-header class="report_header" :isReport="true">
    <template v-if="applyData" v-slot:extra>
      <div v-if="isShowSampling" class="sampling-wrap">
        <span class="sampling" @mouseover="isShowSamplingTooltip = true" @mouseleave="isShowSamplingTooltip = false">
          {{ applyData.meta.samplingRate }}% {{ $t('dashboard.sampling') }}
        </span>
        <ui-tooltip v-if="isShowSamplingTooltip"
                    arrowTop
                    arrowLeft
                    class="sampling-tooltip"
                    :class="$i18n.locale"
        >
          <p v-html="$t('dashboard.samplingTooltip', {rate: applyData.meta.samplingRate })"></p>
        </ui-tooltip>
      </div>
      <a class="link_to_site" :href="applyData | applyUrl" target="_blank">
        <i class="icon icon--link-site-size20"></i>
      </a>
      <div class="site_area">
        <div class="url" href="#" @click.stop.prevent="togglePageList">
          <p class="site_url">
            <span class="matchType_string">{{ applyData.matchType | matchType }}</span>
            <span class="url_string">{{ applyData | applyUrlStr }}</span>
          </p>
          <i class="icon icon--url-btn"></i>
        </div>
      </div>
    </template>
  </app-header>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import { triggerClickEvent } from '@/libs/utils'
import AppHeader from './'
import UiTooltip from '@/components/ui/UiTooltip.vue'

export default {
  name: 'ReportHeader',
  components: {
    UiTooltip,
    AppHeader
  },
  data () {
    return {
      isShowSamplingTooltip: false
    }
  },
  computed: {
    ...mapState([
      'applyData',
      'showReportPageList',
      'reportPeriod'
    ]),
    isShowSampling () {
      return this.applyData && this.applyData.meta && (this.applyData.meta.samplingRate < 100 && this.applyData.meta.samplingRate !== null)
    }
  },
  mounted () {
    EventBus.$on('closeReportPageList', () => {
      this.setShowReportPageList(false)
    })
  },
  methods: {
    ...mapMutations([
      'setShowReportPageList'
    ]),
    togglePageList () {
      EventBus.$emit('closeAllUiSelectBox')
      EventBus.$emit('closeUserMenu')
      EventBus.$emit('closeDateRangePicker')
      EventBus.$emit('closeReferrerList')
      if (!this.showReportPageList) {
        triggerClickEvent()
      }
      this.setShowReportPageList(!this.showReportPageList)
    },
    onRangeCancel () {
      this.closePicker()
    }
  }
}
</script>

<style lang="scss">
.report_header {
  & > div {
    transition: all 0.3s;
  }

  .sampling-wrap {
    position: relative;

    .sampling {
      display: inline-flex;
      align-items: center;
      padding: 4px 5px;
      color: #FFF;
      font-size: 12px;
      font-weight: 500;
      line-height: 100%; /* 12px */
      border-radius: 4px;
      background: linear-gradient(93deg, #0074FF 0%, #1783BA 63.5%, #57AB00 100%);
      box-sizing: border-box;
      margin-right: 8px;
    }

    .sampling-tooltip {
      position: absolute;
      top: 30px;
      left: 145%;
      z-index: 2;
      transform: translateX(-50%);
      .text {
        text-align: left;
      }

      &.en {
        left: 155%;
      }

      &.ja {
        left: 138%;
      }
    }
  }

  .link_to_site {
    color: #fff;
    cursor: pointer;
    margin-right: 10px;
  }

  .site_area {
    height: 19px;
    display: flex;
    align-items: center;
    width: calc(100% - 236px);
  }
  .site_area .type {
    height: 28px;
    line-height: 28px;
    display: inline-block;
    width: 100px;
    margin-right: 13px;
    border-radius: 5px;
    border: 1px solid #4fbae1;
    vertical-align: top;
    color: #4fbae1;
    text-align: center;
  }
  .site_area .url {
    display: flex;
    align-items: center;
    max-width: 500px;
    width: 100%;
  }
  .site_area .site_url {
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .icon--url-btn {
    flex: 0 0 16px;
  }
  .window .site_area .site_url {
    position: relative;
  }
  .site_area .site_url .matchType_string {
    display: inline-block;
    box-sizing: border-box;
    padding: 0 4px;
    height: 16px;
    line-height: 16px;
    border-radius: 4px;
    background-color: #8d8d8d;
    font-size: 12px;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    margin-right: 8px;
  }
  .site_area .site_url .url_string{
    font-size: 14px;
    color: #444444;
  }
  .site_area svg {
    margin-left: 5px;
  }
  .site_area > .url {
    cursor: pointer;
  }
}
</style>
